import axios from 'axios';
// import * as XLSX from 'xlsx';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';


const API_URL = process.env.VUE_APP_API_URL; 

// Create an axios instance
const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor to include the token
// apiClient.interceptors.request.use((config) => {
//   const token = localStorage.getItem('authToken'); 
//   if (token) {
//     config.headers['Authorization'] = `Bearer ${token}`;
//   }
//   return config;
// }, (error) => {
//   return Promise.reject(error);
// });
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken'); 

  if (token && config.includeToken !== false) {
    config.headers['Authorization'] = `Bearer ${token}`; 
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});
let NetworkService = {
  
  
  connector: apiClient,

  /**
   * GET request with parameters
   * @param endpoint
   * @param params 
   * @param config
   * @return {Promise<any>}
   */
  get: function (endpoint, params = {}) {
    return new Promise((resolve, reject) => {
      this.connector.get(endpoint, { params: params })
        .then(response => resolve(response.data))
        .catch(error => reject(this.errorHandler(error)));
    });
  },

  /**
   * POST request with options
   * @param endpoint
   * @param options
   * @param config
   * @return {Promise<any>}
   */
  post: function (endpoint, options = {}, config = {}) {
    
    return new Promise((resolve, reject) => {
      this.connector.post(endpoint, options, config)
        .then(response => resolve(response))
        .catch(error => reject(this.errorHandler(error)));
    });
  },

  /**
   * PUT request with options
   * @param endpoint
   * @param options
   * @return {Promise<any>}
   */
  put: function (endpoint, options) {
    return new Promise((resolve, reject) => {
      this.connector.put(endpoint, options)
        .then(response => resolve(response))
        .catch(error => reject(this.errorHandler(error)));
    });
  },

  /**
   * PATCH request with options
   * @param endpoint
   * @param options
   * @return {Promise<any>}
   */
  patch: function (endpoint, options) {
    return new Promise((resolve, reject) => {
      this.connector.patch(endpoint, options)
        .then(response => resolve(response))
        .catch(error => reject(this.errorHandler(error)));
    });
  },

  /**
   * DELETE request with options
   * @param endpoint
   * @param options
   * @return {Promise<any>}
   */
  delete: function (endpoint, options) {
    return new Promise((resolve, reject) => {
      this.connector.delete(endpoint, options)
        .then(response => resolve(response))
        .catch(error => reject(this.errorHandler(error)));
    });
  },

  // errorHandler: function (error) {
  //   let response = error.response || {};

  //   let message = 'An unexpected error occurred,Please wait for sometime.';
  //   let errors = {};
  //   if (response.data) {
  //     message = response.data.message || message;
  //     errors = response.data.errors || {}; // Capture validation errors
  //   }
  
  //   if (response.status) {
  //     switch (response.status) {
  //       case 401:
  //         message = response.data.message||'Unauthorized access. Please log in.';
  //         localStorage.removeItem('authToken');
  //         break;
  //         case 404:
  //           message = response.data.message || 'The requested resource was not found.' ;
  //           break;
  //           case 422:
  //           message = response.data.message|| 'Validation error. Please check your input.';
  //           errors = response.data.errors || {};
  //           break;
  //       case 419:
  //         if (window.location.pathname.indexOf('login') < 0) {
  //           window.location.href = '/';
  //           return;
  //         }
  //         message = "Session expired. Please log in again.";
  //         break;
  //       case 500:
  //         message = response.data.message||'An internal server error occurred. Please try again later.';
  //         break;
  //       default:
  //         message = response.data?.message || message;
  //     }
  //   }
  
  //   return { message,errors };
  // },
   errorHandler: function (error) {
    if (error.response && error.response.data) {
      console.error("API Error Response (Original):", error.response.data);
      return error.response.data;
    }
    let message = 'An unexpected error occurred. Please try again later.';
    let errors = {}; 

    if (error.request) {
      message = "Network error: Please check your internet connection.";
    } else if (error.message) {
      message = error.message;
    }
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          if (!error.response.data || !error.response.data.message) {
             message = 'Unauthorized access. Please log in.';
          }
          localStorage.removeItem('authToken');
          break;
        case 404:
          if (!error.response.data || !error.response.data.message) {
             message = 'The requested resource was not found.';
          }
          break;
        case 422:
          if (!error.response.data || !error.response.data.message) {
             message = 'Validation error. Please check your input.';
          }
          break;
        case 419:
          if (window.location.pathname.indexOf('login') < 0) {
            window.location.href = '/';
            return; 
          }
          message = "Session expired. Please log in again.";
          break;
        case 500:
          if (!error.response.data || !error.response.data.message) {
             message = 'An internal server error occurred. Please try again later.';
          }
          break;
        default:
          if (!error.response.data || !error.response.data.message) {
            message = `Error ${error.response.status}: An unknown server error occurred.`;
          }
          break;
      }
    }

    // This return handles network errors, request config errors,
    // or generic status errors where response.data was not available.
    return { message, errors };
  },

  /**
   * Download file
   * @param endpoint
   * @param fileName
   * @return {Promise<any>}
   */
  // download: function (endpoint, fileName, method = 'GET', payload = null) {
  //   const config = {
  //     responseType: 'blob',
  //   };

  //   const request = method === 'POST'
  //     ? this.connector.post(endpoint, payload, config)
  //     : this.connector.get(endpoint, config);

  //   return request
  //     .then(response => {
  //       console.log(response.headers);
  //       const contentDisposition = response.headers['content-disposition'];
  //       const filenameMatch = contentDisposition.match(/filename=([^;]+)/);

  //       if (filenameMatch && filenameMatch[1]) {
  //         fileName = filenameMatch[1];
  //       }

  //       const url = window.URL.createObjectURL(new Blob([response.data]));
  //       const link = document.createElement('a');

  //       link.href = url;
  //       link.setAttribute('download', fileName);
  //       document.body.appendChild(link);
  //       link.click();
  //       document.body.removeChild(link);
  //       window.URL.revokeObjectURL(url);
  //       return Promise.resolve();
  //     })
  //     .catch(error => {
  //       this.errorHandler(error);
  //       return Promise.reject(error);
  //     });
  // },

  download: function (endpoint, fileName, method = 'GET', payload = null) {
    const config = {
      responseType: 'blob',
    };
  
    const request = method === 'POST'
      ? this.connector.post(endpoint, payload, config)
      : this.connector.get(endpoint, config);
  
    return request
      .then(response => {
        const contentDisposition = response.headers['content-disposition'];
        if (!contentDisposition) {
          fileName = fileName || 'downloaded-file';
        } else {
          const filenameMatch = contentDisposition.match(/filename=([^;]+)/);
          if (filenameMatch && filenameMatch[1]) {
            fileName = filenameMatch[1];
          }
        }
        const contentType = response.headers['content-type'];
  
        if (contentType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
          if (!fileName.endsWith('.xlsx')) {
            fileName += '.xlsx';
          }
        } else if (contentType.includes('application/pdf')) {
          if (!fileName.endsWith('.pdf')) {
            fileName += '.pdf';
          }
        } else {
          fileName += '.pdf';
        }
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);  
       
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url); 
        return Promise.resolve();
        
      })
      .catch(error => {
        this.errorHandler(error);
        return Promise.reject(error);
      });
  },
 async getPaymentMethods() {
    try {
      const res = await this.get("payment-methods-for-pay");
      if (res.status && Array.isArray(res.data)) {
        return res.data.map((method) => ({
          id: method.id,
          name: method.payment_method,
          value: method.payment_method,
        }));
      }
      return [];
    } catch (error) {
      console.error("Error fetching payment methods:", error);
      throw error;
    }
  },
async getPaymentCharges(paymentMethodId,roleId ,requestData = null) {
  try {
    if (requestData) {
      const response = await this.post(`get-payment-charges/${paymentMethodId}/${roleId}`, requestData);
      return response.data;
    } 
  } catch (error) {
    console.error("Error fetching payment charges:", error);
    throw error;
  }
},
// this is reset the payment selected method
async resetPaymentDialog(context) {
  context.selectedPaymentMethod = "";
  context.paymentCharges = null;
  context.cardDetails = {
    cardNumber: "",
    cardHolderName: "",
  };

  if (context.validator?.cardDetails?.cardNumber) {
    context.validator.cardDetails.cardNumber.$reset();
  }

  if (context.validator?.cardDetails?.cardHolderName) {
    context.validator.cardDetails.cardHolderName.$reset();
  }

  context.lastCardDigits = "";
  context.lastCardHolderName = "";
},
   PaymentService: {
    /**
     * Initiate a payment
     * @param {string} paymentMethodId - ID of the payment method
     * @param {object} paymentDetails - Payment details object
     * @returns {Promise<object>} - Order data from payment gateway
     */
//    async initiate(endpoint,paymentMethodId, paymentDetails) {
//   try {
//     const response = await NetworkService.post(
//       `${endpoint}/${paymentMethodId}`,
//        paymentDetails
//     );
// console.log("res line 362,,,,,,,,,,",response);

//     if (!response?.data?.status || !response?.data?.order) {
//       const originalMessage = response?.data?.message || "Invalid payment response";

//       // Replace technical SQL/database errors with a user-friendly message
//       const userFriendlyMessage = originalMessage.includes("SQLSTATE")
//         ? "Something went wrong while processing your payment. Please try again or contact support."
//         : originalMessage;

//       throw new Error(userFriendlyMessage);
//     }

//     return response.data.order.data;
//   } catch (error) {
//     console.error("Payment initiation error:", error);
//     throw error;
//   }
// },

async initiate(endpoint, paymentMethodId, paymentDetails) {
  try {
    const response = await NetworkService.post(
      `${endpoint}/${paymentMethodId}`,
      paymentDetails
    );
    console.log("res line 362,,,,,,,,,,", response);

    if (!response?.data?.status || !response?.data?.order) {
      const originalMessage = response?.data?.message || "Invalid payment response";

      const userFriendlyMessage = originalMessage.includes("SQLSTATE")
        ? "Something went wrong while processing your payment. Please try again or contact support."
        : originalMessage;

      throw new Error(userFriendlyMessage);
    }

    
    return response.data;
  } catch (error) {
    console.error("Payment initiation error:", error);
    throw error;
  }
},

    /**
     * Verify payment status
     * @param {string} orderId - Order ID to verify
     * @returns {Promise<string>} - Payment status (PAID, FAILED, PENDING, ERROR)
     */
    // async verifyStatus(orderId) {
    //   try {
    //     const response = await NetworkService.get(`get-payment-status/${orderId}`);
    //     console.log("response is",response);
        
    //     if (
    //       response.data?.payment_status === "SUCCESS"
    //     ) {
    //       return "SUCCESS";
    //     }
    //     if (
    //       response.data?.payment_status === "FAILED"
    //     ) {
    //       return "FAILED";
    //     }
    //     return "PENDING"; 
    //   } catch (error) {
    //     console.error("Status check error:", error);
    //     return "ERROR";
    //   }
    // },
   async verifyAndHandlePaymentStatus(orderId, context) {
    try {
      const response = await NetworkService.get(`get-payment-status/${orderId}`);
      console.log("res............",response);
      
      if (response.data?.payment_status === "SUCCESS") {
        const successMessage = response.message || "Payment successful";
        context.$refs.toast.show(successMessage, "success");
        context.loading = false;
        setTimeout(() => {
          context.$router.push({ name: "ThankYou" });
        }, 3000);
      } 
      else if (response.data?.payment_status === "FAILED") {
        setTimeout(() => {
          context.loading = false;
          context.$refs.toast.show(response.message || "Payment failed", "error");
        }, 3000);
      } 
      else if (response.data?.payment_status === "PENDING") {
        setTimeout(() => {
          context.loading = false;
          context.$refs.toast.show(response.message || "Payment is still pending", "info");
        }, 3000);
      } 
      else {
        context.loading = false;
        context.$refs.toast.show(response.message || "Payment Failed", "error");
      }
    } catch (error) {
      context.loading = false;
      const errorInfo = this.handleError(error);
      if (context?.$refs?.toast) {
    context.$refs.toast.show(errorInfo.message, "error");
  } else {
    console.error("Payment Failed", errorInfo.message);
  }
    }
  },
    /**
     * Process Cashfree payment
     * @param {string} paymentSessionId - Cashfree payment session ID
     * @returns {Promise<object>} - Cashfree checkout result
     */
    async processCashfree(paymentSessionId) {
      if (!window.Cashfree) {
        throw new Error("Cashfree SDK not loaded");
      }
      
      const cashfree = window.Cashfree({ mode: "sandbox" });
      const checkoutOptions = {
        paymentSessionId: paymentSessionId,
        redirectTarget: "_modal",
      };

      const result = await cashfree.checkout(checkoutOptions);

      if (result.error) {
        throw new Error("Unable to process the payment");
      }

      if (!result.paymentDetails) {
        throw new Error("Payment could not be completed. Please try again.");
      }

      return result;
    },

    /**
     * Handle payment error (can be used by components)
     * @param {Error} error - Error object
     * @returns {object} - Formatted error message and details
     */
    handleError(error) {
      return {
        // message: error.response?.data?.message || error.message || "Payment processing failed. Please try again.",
        message: '' || "Payment processing failed. Please try again.",
        error: error
      };
    }
  },

  /**
   * Encode Query parameters
   *
   * @param params
   * @returns {string}
   */
  encodeQueryParams: function (params) {
    return Object.keys(params)
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
      .join('&')
      .replace(/%2B/g, '+');
  },
};

export default NetworkService;
